
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Navigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isCurrentPage = (path: string) => location.pathname === path;

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 w-full bg-stone-50/95 backdrop-blur-md shadow-md border-b border-amber-200/30">
      <div className="max-w-7xl mx-auto px-4 py-3">
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-center gap-8">
          <Link to="/" onClick={handleLinkClick} className="cursor-pointer">
            <h1
              className="text-xl font-bold text-red-700 tracking-wide hover:text-red-800 transition-colors duration-300"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              CAPITAL PUNISHMENT
            </h1>
          </Link>

          <div className="flex items-center space-x-6">
            <Link
              to="/"
              onClick={handleLinkClick}
              className={`text-base text-stone-700 hover:text-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap font-medium ${
                isCurrentPage('/') ? 'text-amber-800 font-semibold' : ''
              }`}
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              Início
            </Link>
            <Link
              to="/blog"
              onClick={handleLinkClick}
              className={`text-base text-stone-700 hover:text-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap font-medium ${
                isCurrentPage('/blog') ? 'text-amber-800 font-semibold' : ''
              }`}
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              Artigos
            </Link>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="flex md:hidden items-center justify-between">
          <Link to="/" onClick={handleLinkClick} className="cursor-pointer">
            <h1
              className="text-lg font-bold text-red-700 tracking-wide"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              CAPITAL PUNISHMENT
            </h1>
          </Link>

          {/* Hamburger Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="w-10 h-10 flex items-center justify-center text-stone-700 hover:text-red-700 transition-colors cursor-pointer"
            aria-label="Menu"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            isMenuOpen ? 'max-h-40 opacity-100 mt-4' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="flex flex-col space-y-3 pb-4 border-t border-amber-200/50 pt-4">
            <Link
              to="/"
              onClick={handleLinkClick}
              className={`text-base text-stone-700 hover:text-amber-700 transition-colors duration-300 cursor-pointer font-medium py-2 ${
                isCurrentPage('/') ? 'text-amber-800 font-semibold' : ''
              }`}
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              Início
            </Link>
            <Link
              to="/blog"
              onClick={handleLinkClick}
              className={`text-base text-stone-700 hover:text-amber-700 transition-colors duration-300 cursor-pointer font-medium py-2 ${
                isCurrentPage('/blog') ? 'text-amber-800 font-semibold' : ''
              }`}
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              Artigos
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
